import Axios from 'axios'
import _, { get, remove } from 'lodash'
import { vueAppApiBaseAddress } from '@/utils/mixins'
import * as Constants from '../../constants'

var initialState = {
  apparatusSubscriptionsGettingReady: [],
  subscriptionCancelInitiated: false
}

export const state = _.cloneDeep(initialState)
export const getters = {
  apparatusSubscriptionsGettingReady: (state, getters, rootState) => state.apparatusSubscriptionsGettingReady,
  subscriptionCancelInitiated: (state, getters, rootState) => state.subscriptionCancelInitiated
}
export const mutations = {
  setPremiumFeaturesGettingReadyInfo(state, apparatusSubscriptionData) {
    state.apparatusSubscriptionsGettingReady = [...state.apparatusSubscriptionsGettingReady, apparatusSubscriptionData]
  },
  clearPremiumFeaturesGettingReadyInfo(state) {
    state.apparatusSubscriptionsGettingReady = []
  },
  removePremiumFeaturesGettingReadyInfo(state, apparatusId) {
    state.apparatusSubscriptionsGettingReady = state.addPremiumFeaturesGettingReadyInfo?.filter(
      apparatus => apparatus.apparatusId !== apparatusId
    )
  },
  setSubscriptionsCancelInitiated(state, isSubscriptionCancelInitiated) {
    state.subscriptionCancelInitiated = isSubscriptionCancelInitiated
  }
}

export const actions = {
  async getPremiumFeaturesGettingReadyInfo({ commit }) {
    return this.state.subscriptions.apparatusSubscriptionsGettingReady
  },
  async addPremiumFeaturesGettingReadyInfo({ commit }, apparatusSubscriptionData) {
    commit('setPremiumFeaturesGettingReadyInfo', apparatusSubscriptionData)
  },
  async deletePremiumFeaturesGettingReadyInfo({ commit }, apparatusId) {
    commit('removePremiumFeaturesGettingReadyInfo', apparatusId)
  },
  async setSubscriptionPendingCancel({ commit }, isSubscriptionCancelInitiated) {
    commit('setSubscriptionsCancelInitiated', isSubscriptionCancelInitiated)
  },
  async getSubscriptionProductByApparatusId({ commit }, apparatusId) {
    return await Axios.get(vueAppApiBaseAddress() + `v1/Subscription/products/${apparatusId}`, {
      withCredentials: true
    })
  },
  async getSubscriptionProductsByDeviceType({ commit }, deviceType) {
    return await Axios.get(vueAppApiBaseAddress() + `v1/Subscription/products/Generator/${deviceType}`, {
      withCredentials: true
    })
  },
  async getActivePaymentMethod({ commit }, organizationId) {
    return await Axios.get(vueAppApiBaseAddress() + `v1/Subscription/payment/${organizationId}`, {
      withCredentials: true
    })
  },
  async changeBillingAccountProduct({ commit }, request) {
    return await Axios.put(vueAppApiBaseAddress() + `v1/Subscription/products/change`, request, {
      withCredentials: true
    })
  },
  async getSubscriptionDetails({ commit }, organizationId) {
    return await Axios.get(vueAppApiBaseAddress() + `v4/Subscription/details/${organizationId}`, {
      withCredentials: true
    })
  },
  async removeBillingAccountPaymentMethod({ commit }, request) {
    return await Axios.put(
      vueAppApiBaseAddress() + `v1/Subscription/payment/${parseInt(request.organizationId)}/${request.paymentId}`,
      {},
      {
        withCredentials: true
      }
    )
  },
  async addBillingAccountPaymentMethod({ commit }, request) {
    return await Axios.post(
      vueAppApiBaseAddress() + `v1/Subscription/payment/${parseInt(request.organizationId)}`,
      {
        cardNumber: request.cardNumber,
        cvv: request.cvv,
        expirationMonth: request.expirationMonth,
        expirationYear: request.expirationYear
      },
      {
        withCredentials: true
      }
    )
  },
  async getApparatusSubscription({ commit }, request) {
    return await Axios.get(
      vueAppApiBaseAddress() + `v1/Subscription/account/${request.organizationId}/${request.apparatusId}`,
      {
        withCredentials: true
      }
    )
  },
  async getAllApparatusSubscriptions({ commit }, request) {
    return await Axios.get(vueAppApiBaseAddress() + `v1/Subscription/account/active/${request.organizationId}`, {
      withCredentials: true
    })
  },
  async getOrganizationSubscriptionDetails({ commit }, request) {
    return await Axios.get(vueAppApiBaseAddress() + `v4/Subscription/details/${request.organizationId}`, {
      withCredentials: true
    })
  },
  async cancelApparatusSubscription({ commit }, request) {
    return await Axios.delete(
      vueAppApiBaseAddress() + `v1/Subscription/products/${request.organizationId}/${request.apparatusId}`,
      {
        withCredentials: true
      }
    )
  },
  async findAccountInvoices({ commit }, request) {
    return await Axios.get(vueAppApiBaseAddress() + `v1/Subscription/find/invoices/${request.organizationId}`, {
      withCredentials: true
    })
  },
  async downloadInvoice({ commit }, request) {
    return await Axios.get(
      vueAppApiBaseAddress() + `v1/Subscription/download/invoice/${request.organizationId}/${request.invoiceId}`,
      {
        withCredentials: true,
        responseType: 'blob'
      }
    )
  },
  async getSubscriptionDetails({ commit }, organizationId) {
    return await Axios.get(vueAppApiBaseAddress() + `v4/Subscription/details/${organizationId}`, {
      withCredentials: true
    })
  },
  async getSubscriptionProductsByStoreOrganization({ commit }, request) {
    return await Axios.get(
      vueAppApiBaseAddress() +
        `v5/Subscription/recommendedStoreProducts/${Constants.WebSubscriptionStore}/${request.organizationId}`,
      {
        withCredentials: true
      }
    )
  },
  async getSubscriptionProductsByStoreOrganizationApparatusToAdd({ commit }, request) {
    return await Axios.get(
      vueAppApiBaseAddress() +
        `v5/Subscription/recommendedStoreProducts/${Constants.WebSubscriptionStore}/${request.organizationId}?apparatusTypeToAdd=${request.apparatusTypeToAdd}`,
      {
        withCredentials: true
      }
    )
  },
  async getSubscriptionProductsByStoreOrganizationApparatusToRemove({ commit }, request) {
    return await Axios.get(
      vueAppApiBaseAddress() +
        `v5/Subscription/recommendedStoreProducts/${request.store}/${request.organizationId}?apparatusTypeToRemove=${request.apparatusTypeToRemove}`,
      {
        withCredentials: true
      }
    )
  },
  async getAllWebSubscriptionProducts({ commit }) {
    return await Axios.get(vueAppApiBaseAddress() + `v5/Subscription/products/all/${Constants.WebSubscriptionStore}`, {
      withCredentials: true
    })
  },
  async updateSubscriptionProduct({ commit }, request) {
    return await Axios.put(
      vueAppApiBaseAddress() +
        `v1/Subscription/updateSubscriptionProduct/${request.organizationId}/${Constants.SubscriptionStoreTypes.WEB}/${request.productId}`,
      {},
      {
        withCredentials: true
      }
    )
  },
  async createPurchaseIntent({ commit }, request) {
    return await Axios.post(
      vueAppApiBaseAddress() +
        `v4/Subscription/purchaseIntent/${request.organizationId}/${Constants.SubscriptionStoreTypes.WEB}/${request.productId}`,
      request.apparatusIds,
      {
        withCredentials: true
      }
    )
  },
  async updateSubscriptionApparatuses({ commit }, request) {
    return await Axios.put(
      vueAppApiBaseAddress() +
        `v1/Subscription/updateSubscriptionApparatuses/${request.organizationId}/${request.store}/${request.productId}`,
      request.apparatusIds,
      {
        withCredentials: true
      }
    )
  },
  async cancelSubscriptionProduct({ commit }, request) {
    return await Axios.delete(
      vueAppApiBaseAddress() +
        `v1/Subscription/subscriptionProduct/${request.organizationId}/${request.store}/${request.productId}`,
      {
        withCredentials: true,
        responseType: 'blob'
      }
    )
  },
  async cancelSubscriptionProductImmediately({ commit }, request) {
    return await Axios.put(vueAppApiBaseAddress() + `v1/Subscription/subscriptionProduct/deleteImmediately`, request, {
      withCredentials: true
    })
  },
  async storeSubscriptionTermsConsent({ commit }, organizationId) {
    return await Axios.post(
      vueAppApiBaseAddress() + `v4/Subscription/storeSubscriptionTermsConsent/${organizationId}`,
      {},
      {
        withCredentials: true,
        responseType: 'blob'
      }
    )
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
